import {FirebaseAuthentication} from '@capacitor-firebase/authentication';
import {establishNativeSession} from './session';

export async function signInWithNativeFirebase(
  provider: 'google' | 'apple',
  minimumAgeConfirmed = false,
) {
  const result =
    provider === 'google'
      ? await FirebaseAuthentication.signInWithGoogle()
      : await FirebaseAuthentication.signInWithApple();
  const idToken = result.credential?.idToken;
  if (!idToken) {
    throw new Error(`${provider} sign-in did not return an identity token.`);
  }
  return establishNativeSession(
    idToken,
    result.user?.displayName,
    minimumAgeConfirmed,
  );
}

export async function signOutNativeFirebase() {
  await FirebaseAuthentication.signOut();
}
